import React from 'react';
import { useEffect, useState } from 'react';
import { Card, Button, Row, Col, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DirectoryService from 'components/app/directory/DirectoryService';
import Avatar from 'components/common/Avatar';
import defaultAvatar from 'assets/img/team/avatar.png';
import { Badge, Form } from 'react-bootstrap';
import { text } from '@fortawesome/fontawesome-svg-core';
import { doc } from 'prettier';
import OnBoardingService from 'components/app/directory/OnBoardingService';
import { useNavigate } from 'react-router-dom';
import OnboardingWidgetItem from './OnboardingWidgetItem';

const OnboardingWidget = () => {
  const [tasks, setTasks] = React.useState([]);
  const [employees, setEmployees] = React.useState({});
  const [selectedTasks, setSelectedTasks] = React.useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    DirectoryService.retrieveUsersByAccount().then(profiles => {
      const employeeObj = Object.fromEntries(
        profiles.map(emp => [emp.identifier, emp])
      );
      setEmployees(employeeObj);

      const profile = DirectoryService.retrieveLoggedProfile();
      DirectoryService.retrieveToDoList().then(tasks => {
        const onboardingTasks = tasks.filter(
          task => task.onboardingTask && task.done && task.status !== 'reviewed'
        );
        const generatedTasks = onboardingTasks.map(item => ({
          id: item.identifier,
          task: item.title,
          title: item.title,
          priority: item.priority,
          dueDate: item.dueDate,
          employeeName: profile.firstName + ' ' + profile.lastName,
          employeeIdentifier: profile.identifier,
          profileIdentifier: item.profile_identifier,
          employee: employees[item.employeeIdentifier],
          done: false,
          type: item.type,
          status: item.status,
          text: item.text,
          onboardingTask: true,
          documents: item.documents || []
        }));
        console.log('generatedTasks:', generatedTasks);
        setTasks(generatedTasks);
      });
    });
  }, []);
  return (
    <Card className="h-100">
      <Card.Header>
        <h6 className="fs-0 text-capitalize">Onboarding</h6>
      </Card.Header>
      <Card.Body className="p-0 overflow-hidden" id="todoList">
        {tasks.length > 0 ? (
          tasks.slice(0,4).map(item => (
            <OnboardingWidgetItem
              key={item.identifier}
              task={item}

            />
          ))
        ) : (
          <p className="text-center m-0 p-3">No onboarding tasks assigned.</p>
        )}
      </Card.Body>
      <Card.Footer className="p-0 text-center">
        <Button
          as={Link}
          variant="link"
          size="sm"
          to="#!"
          id="see-all-onboarding-tasks"
          onClick={() => navigate('/hr/onboarding')}
          className="w-100 py-2"
        >
          See all onboarding tasks
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default OnboardingWidget;
